// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingStressPersonalIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={22} cy={22} r={22} fill="url(#OnboardingStressPersonalIcon_tsx__a)" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.23 23.889c0-.275-.085-.689-.486-1.104a.666.666 0 1 0-.958.928c.082.084.11.147.11.176 0 .282-1.282 1.096-3.73 1.096-2.447 0-3.73-.814-3.73-1.096 0-.029.03-.091.11-.175a.667.667 0 0 0-.958-.928c-.4.414-.485.828-.485 1.103 0 1.595 2.547 2.43 5.064 2.43 2.515 0 5.063-.835 5.063-2.43Zm-2.395-7.888a2.986 2.986 0 0 1-2.668 4.315c-.797 0-1.546-.31-2.11-.873a2.962 2.962 0 0 1-.873-2.109c0-.468.106-.917.314-1.332.34-.682 1.688-2.314 2.669-3.372.98 1.058 2.327 2.69 2.668 3.371Zm1.647 1.333c0-.677-.153-1.327-.454-1.93-.532-1.062-2.519-3.338-3.39-4.209a.667.667 0 0 0-.943 0c-.871.872-2.858 3.147-3.39 4.21a4.273 4.273 0 0 0-.454 1.93c0 1.152.449 2.236 1.264 3.051a4.288 4.288 0 0 0 3.052 1.264 4.32 4.32 0 0 0 4.315-4.316Zm8.851 8.034c0-1.911-.908-3.597-2.625-4.874a.666.666 0 1 0-.796 1.07c1.385 1.03 2.088 2.31 2.088 3.804 0 3.394-5.419 6.262-11.834 6.262-6.414 0-11.833-2.868-11.833-6.262 0-1.523.65-2.802 1.931-3.803a.666.666 0 1 0-.82-1.051C9.845 21.763 9 23.441 9 25.368c0 4.259 5.783 7.596 13.166 7.596 7.384 0 13.167-3.337 13.167-7.596Zm-13.167 3.965c-5.158 0-9.199-2.125-9.199-4.84 0-1.115.713-2.178 2.007-2.991a.667.667 0 1 1 .71 1.129c-.892.56-1.384 1.222-1.384 1.863C14.3 26.56 18.446 28 22.166 28c3.721 0 7.867-1.44 7.867-3.506 0-.647-.514-1.308-1.446-1.864a.667.667 0 0 1 .682-1.146c1.352.806 2.097 1.875 2.097 3.01 0 2.713-4.041 4.839-9.2 4.84Z"
			fill="#fff"
		/>
		<defs>
			<linearGradient
				id="OnboardingStressPersonalIcon_tsx__a"
				x1={0}
				y1={0}
				x2={44}
				y2={44}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75F0F0" />
				<stop offset={1} stopColor="#7575F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingStressPersonalIcon;
